import { render, staticRenderFns } from "./OneColumn.vue?vue&type=template&id=2a01300c&scoped=true&"
import script from "./OneColumn.vue?vue&type=script&lang=ts&"
export * from "./OneColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a01300c",
  null
  
)

export default component.exports